import styles from './CategoriesAndSkills.module.css';
import {
  CategoriesAndSkillsDesktop,
  CategoriesAndSkillsMobile,
} from '../../../components/molecules';
import { useIsMobile, useIsTablet } from '@/hooks';
import { useLanguage } from '@/contexts/LanguageContext';

export function CategoriesAndSkills() {
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();
  const { t } = useLanguage();

  // Categories for the left navigation (using translations)
  const categoryItems = [
    { label: t('home.categories.strategy'), href: '/strategy', active: false },
    { label: t('home.categories.creation'), href: '/creation', active: false },
    {
      label: t('home.categories.production'),
      href: '/production',
      active: false,
    },
    {
      label: t('home.categories.distribution'),
      href: '/distribution',
      active: false,
    },
  ];

  // Skills data for each category (using translations from database)
  const skillsData = [
    // Strategy skills
    [
      {
        title: t('home.skills.strategy.research.title'),
        skills: [
          t('home.skills.strategy.research.market-analysis'),
          t('home.skills.strategy.research.user-research'),
          t('home.skills.strategy.research.benchmarking'),
        ],
      },
      {
        title: t('home.skills.strategy.targeting.title'),
        skills: [
          t('home.skills.strategy.targeting.personas'),
          t('home.skills.strategy.targeting.segmentation'),
          t('home.skills.strategy.targeting.positioning'),
        ],
      },
      {
        title: t('home.skills.strategy.consulting.title'),
        skills: [
          t('home.skills.strategy.consulting.digital-strategy'),
          t('home.skills.strategy.consulting.transformation'),
          t('home.skills.strategy.consulting.innovation'),
        ],
      },
    ],
    // Creation skills
    [
      {
        title: t('home.skills.creation.design.title'),
        skills: [
          t('home.skills.creation.design.ui-ux'),
          t('home.skills.creation.design.brand-identity'),
          t('home.skills.creation.design.motion-design'),
        ],
      },
      {
        title: t('home.skills.creation.concept.title'),
        skills: [
          t('home.skills.creation.concept.wireframes'),
          t('home.skills.creation.concept.prototypes'),
          t('home.skills.creation.concept.design-systems'),
        ],
      },
      {
        title: t('home.skills.creation.art-direction.title'),
        skills: [
          t('home.skills.creation.art-direction.visual-identity'),
          t('home.skills.creation.art-direction.brand-guidelines'),
          t('home.skills.creation.art-direction.storytelling'),
        ],
      },
    ],
    // Production skills
    [
      {
        title: t('home.skills.production.development.title'),
        skills: [
          t('home.skills.production.development.frontend'),
          t('home.skills.production.development.backend'),
          t('home.skills.production.development.mobile'),
        ],
      },
      {
        title: t('home.skills.production.integration.title'),
        skills: [
          t('home.skills.production.integration.cms'),
          t('home.skills.production.integration.e-commerce'),
          t('home.skills.production.integration.api'),
        ],
      },
      {
        title: t('home.skills.production.optimization.title'),
        skills: [
          t('home.skills.production.optimization.performance'),
          t('home.skills.production.optimization.seo'),
          t('home.skills.production.optimization.accessibility'),
        ],
      },
    ],
    // Distribution skills
    [
      {
        title: t('home.skills.distribution.marketing.title'),
        skills: [
          t('home.skills.distribution.marketing.social-media'),
          t('home.skills.distribution.marketing.email'),
          t('home.skills.distribution.marketing.content'),
        ],
      },
      {
        title: t('home.skills.distribution.acquisition.title'),
        skills: [
          t('home.skills.distribution.acquisition.sea'),
          t('home.skills.distribution.acquisition.display'),
          t('home.skills.distribution.acquisition.affiliation'),
        ],
      },
      {
        title: t('home.skills.distribution.analytics.title'),
        skills: [
          t('home.skills.distribution.analytics.tracking'),
          t('home.skills.distribution.analytics.reporting'),
          t('home.skills.distribution.analytics.data-visualization'),
        ],
      },
    ],
  ];

  return (
    <div className={styles.categoriesAndSkillsSection} id="skills-and-services">
      {isMobile || isTablet ? (
        <>
          <CategoriesAndSkillsMobile
            items={categoryItems}
            skills={skillsData}
          />
        </>
      ) : (
        <>
          <CategoriesAndSkillsDesktop
            items={categoryItems}
            skills={skillsData}
          />
        </>
      )}
    </div>
  );
}
